interface BrandedLoaderProps {
  compact?: boolean;
}

export const BrandedLoader = ({ compact = false }: BrandedLoaderProps) => (
  <div
    className={compact
      ? "flex min-h-48 flex-col items-center justify-center px-4 py-12"
      : "flex min-h-screen flex-col items-center justify-center bg-background px-4"
    }
    role="status"
    aria-label="Loading"
  >
    <img
      src="/favicon.png"
      alt=""
      width={compact ? 56 : 72}
      height={compact ? 56 : 72}
      className={compact ? "mb-5 h-14 w-14 object-contain" : "mb-[22px] h-[72px] w-[72px] object-contain"}
    />
    <div className={compact ? "h-1 w-32 overflow-hidden rounded-full bg-muted" : "h-1 w-40 overflow-hidden rounded-full bg-muted"}>
      <div className="h-full w-1/3 rounded-full bg-primary animate-[loader-slide_1.2s_ease-in-out_infinite] motion-reduce:animate-none" />
    </div>
    <style>{`@keyframes loader-slide{0%{transform:translateX(-100%)}100%{transform:translateX(400%)}}`}</style>
  </div>
);